export default __webpack_public_path__ + "932b94156b07367e56c98cceb5f302e9.png";